import { useManagerActions } from 'legacy/lut/components/widgets/public/partner360/commitment/addMoreBtn/hooks/useManagerActions'
import { usePartnerActions } from 'legacy/lut/components/widgets/public/partner360/commitment/addMoreBtn/hooks/usePartnerActions'
import { usePBMActions } from 'legacy/lut/components/widgets/public/partner360/commitment/addMoreBtn/hooks/usePBMActions'
import { AcknowledgmentAction } from 'legacy/lut/components/widgets/public/partner360/commitment/enums/AckonwledgmentAction'
import { CommitmentTypes } from 'legacy/lut/components/widgets/public/partner360/commitment/models'
import { HPContactsTable } from 'legacy/lut/components/widgets/public/partner360/hpContactsTable/HPContactsTable'
import {
  IRequestAcknowledgementParameters,
  requestAcknowledgement,
} from 'legacy/lut/features/partner360/commitment'
import React, { useCallback, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'
import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'
import MeasureController from 'core/analytics/MeasureController'
import {
  GpContactsListDialog,
  IJbpGlobalPartnerPartnersContact,
} from 'partner360/widgets/gp360ContactsTable/components/gpContactsListDialog'

import { useAppDispatch } from '../../../../../../hooks/useAppDispatch'
import { ManagerChangeDialog } from '../dialogs/managerChangeDalog/ManagerSelectDialog'
import { PartnerChangeDialog } from '../dialogs/partnerChangeDialog/PartnerChangeDialog'

import styles from './AddMoreButton.module.scss'

interface IProps {
  ackPartialInfo: IObjectAny
  commitmentType: string
  pid: string
  metrics: MeasureController
  flexWidth: FlexDirectionBreak
  pbmList: string[]
  partnerId: string
  setIsRefuseCurrentItem: (value: boolean) => void
  widgetParams: IObjectAny
  checkContactIsUnique: (email: string) => boolean
}

export const AddMoreButton = ({
  commitmentType,
  pid,
  metrics,
  flexWidth,
  pbmList,
  partnerId,
  setIsRefuseCurrentItem,
  ackPartialInfo,
  widgetParams,
  checkContactIsUnique,
}: IProps) => {
  const dispatch = useAppDispatch()
  const { addPBM, showSelectPBMModal, openPMBSelectModal, closePMBSelectModal } = usePBMActions({
    ackPartialInfo,
    checkContactIsUnique,
  })

  const { closeManagerSelectModal, showSelectManagerModal, openManagerSelectModal } =
    useManagerActions()

  const {
    closePartnerSelectModal,
    openPartnerSelectModal,
    showSelectPartnerModal,
    setShowSelectPartnerModal,
  } = usePartnerActions()

  const isGlobalPartner = useMemo(() => partnerId.startsWith('GP'), [partnerId])

  const addMoreHandler = (commitmentType: string) => () => {
    if (commitmentType === CommitmentTypes.PBM) {
      openPMBSelectModal()
    }
    if (commitmentType === CommitmentTypes.Manager) {
      openManagerSelectModal()
    }
    if (commitmentType === CommitmentTypes.Partner) {
      openPartnerSelectModal()
    }
  }

  const callAcknowledgmentAction = useCallback(
    (parameters: IRequestAcknowledgementParameters) => {
      return dispatch(requestAcknowledgement(parameters))
    },
    [dispatch]
  )

  const handleGPSelect = useCallback(
    async (selectedProfile: IJbpGlobalPartnerPartnersContact) => {
      closeManagerSelectModal()
      if (selectedProfile.Email && !checkContactIsUnique(selectedProfile.Email)) {
        return
      }
      await callAcknowledgmentAction({
        partnerId: ackPartialInfo.PartnerId,
        fYear: ackPartialInfo.FYear,
        programType: ackPartialInfo.ProgramType,
        entryId: null,
        actionData: {
          Action: AcknowledgmentAction.Add,
          Email: selectedProfile.Email,
          FirstName: selectedProfile.FirstName,
          LastName: selectedProfile.LastName,
          ContactId: selectedProfile.ContactID,
          CommitmentType: ackPartialInfo.CommitmentType,
        },
      })
    },
    [checkContactIsUnique, ackPartialInfo, closeManagerSelectModal, callAcknowledgmentAction]
  )

  return (
    <div className={styles.btn}>
      <Button onClick={addMoreHandler(commitmentType)}>
        <Translation text={'partner commitment-add-more-btn'} />
      </Button>
      <ModalDialog
        content={() => (
          <HPContactsTable
            widgetParams={widgetParams}
            pid={pid}
            metrics={metrics}
            flexWidth={flexWidth}
            settings={{
              showRoleColumn: true,
              hideRoleDropdown: true,
              onSelectRow: addPBM,
              sourceKey: 'multiple-approvers',
              fetchAllRoles: true,
            }}
          />
        )}
        show={showSelectPBMModal}
        closeOnOutsideClick={false}
        onClose={closePMBSelectModal}
      />
      <ManagerChangeDialog
        onClose={closeManagerSelectModal}
        pbmList={pbmList}
        show={showSelectManagerModal}
        action={AcknowledgmentAction.Add}
        ackPartialInfo={ackPartialInfo}
        checkContactIsUnique={checkContactIsUnique}
      />
      {isGlobalPartner ? (
        <GpContactsListDialog
          showModal={showSelectPartnerModal}
          setShowModal={setShowSelectPartnerModal}
          partnerId={partnerId}
          metrics={metrics}
          flexWidth={flexWidth}
          fYear={ackPartialInfo.FYear}
          onSelectProfile={handleGPSelect}
        />
      ) : (
        <PartnerChangeDialog
          show={showSelectPartnerModal}
          partnerId={partnerId}
          setIsRefuseCurrentItem={setIsRefuseCurrentItem}
          onClose={closePartnerSelectModal}
          action={AcknowledgmentAction.Add}
          ackPartialInfo={ackPartialInfo}
          checkContactIsUnique={checkContactIsUnique}
        />
      )}
    </div>
  )
}
